import { ApiRegistryItem, CacheItem, RequestMetrics } from './types'

export const apiRegistry = new Map<string, Set<ApiRegistryItem>>()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pendingRequests = new Map<string, CacheItem<any>>()

export const requestMetrics: RequestMetrics[] = []
